import { Flex, FlexProps, useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { PriceLoadingSkeleton } from "components/PrescriptionFlow/TreatmentSummaryContent/PriceLoadingSkeleton";
import { InfoModal } from "design_system/components/Modal";
import { OFText } from "design_system/components/OFText";
import { InfoEllipseIcon } from "design_system/icons";
import { colors } from "src/colors";
import { addTransSuffixCountry } from "src/utils";
import { formatPrice } from "src/utils/priceFormat";

import { LABEL_TEXT_STYLE, VALUE_TEXT_STYLE } from "./constant/style";

type Props = FlexProps & {
  price: number;
  shouldChargeNow: boolean;
  isEDBundle?: boolean;
  isLoading?: boolean;
  isHideInfo?: boolean;
};

const CheckoutDueSection = ({
  price,
  shouldChargeNow,
  isLoading,
  isEDBundle = false,
  isHideInfo,
  ...props
}: Props) => {
  const checkoutTransKey = addTransSuffixCountry("checkout");
  const { t } = useTranslation(checkoutTransKey);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const canShowInfoIcon = !isHideInfo && (isEDBundle || !shouldChargeNow);

  const infoModal = {
    title: isEDBundle
      ? t(`${checkoutTransKey}:ed-trial-bundle-info.title`)
      : t("checkout:warning-modal-if-prescribed.title"),

    body: isEDBundle
      ? t(`${checkoutTransKey}.ed-trial-bundle-info.description`)
      : t("checkout:warning-modal-if-prescribed.p1")
  };

  return (
    <Flex justify="space-between" align="center" {...props}>
      <Flex align="center">
        <OFText textStyle={LABEL_TEXT_STYLE}>
          {t(`${checkoutTransKey}:${shouldChargeNow ? "due-now" : "pending-doctor-confirmation"}`)}
        </OFText>

        {canShowInfoIcon && (
          <>
            <InfoEllipseIcon color={colors.grey[800]} size={20} onClick={onOpen} cursor="pointer" />

            <InfoModal
              isOpen={isOpen}
              onClose={onClose}
              title={infoModal.title}
              body={infoModal.body}
            />
          </>
        )}
      </Flex>

      <PriceLoadingSkeleton isLoading={isLoading}>
        <OFText
          whiteSpace="pre"
          textAlign="right"
          color={shouldChargeNow ? colors.black[900] : colors.grey[700]}
          textStyle={VALUE_TEXT_STYLE}
        >
          {formatPrice(price)}
        </OFText>
      </PriceLoadingSkeleton>
    </Flex>
  );
};

export default CheckoutDueSection;
